import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { CharField, SelectField } from 'components/forms'
import { METERS, YARDS } from 'shared/units/constants'
import styles from './_workoutForm.css'

const messages = {
  meters: {
    id: 'workout.create.pool_length.meters',
    defaultMessage: 'meters',
  },
  yards: {
    id: 'workout.create.pool_length.yards',
    defaultMessage: 'yards',
  },
}

export class Swim extends Component {

  static propTypes = {
    intl: PropTypes.object,
    onChange: PropTypes.func,
  }

  handleSwimChange = (name) => (evt) => {
    if (evt.target) {
      this.props.onChange(name, evt.target.value)
    } else {
      this.props.onChange(name, evt)
    }
  }

  render () {
    const { intl } = this.props
    return (
      <div>
        <CharField
          bold
          short
          type='number'
          min='0'
          step='1'
          name='laps'
          onChange={this.handleSwimChange('laps')}
          inputContainerClassName={styles.shortInput}
          labelComponent={(
            <FormattedMessage
              id='workouts.create.laps'
              defaultMessage='Laps'
            />
          )}
        />

        <CharField
          bold
          short
          type='number'
          min='0'
          step='any'
          name='poolLength'
          onChange={this.handleSwimChange('poolLength')}
          inputContainerClassName={styles.shortInput}
          labelComponent={(
            <FormattedMessage
              id='workouts.create.pool_length'
              defaultMessage='Pool Length'
            />
          )}
          afterComponent={(
            <SelectField
              slim
              onChange={this.handleSwimChange('poolLengthUnit')}
              className={styles.poolLengthUnit}
              name='poolLengthUnit'
              options={[{
                label: intl.formatMessage(messages.meters),
                value: METERS,
              }, {
                label: intl.formatMessage(messages.yards),
                value: YARDS,
              }]}
            />
          )}
        />
      </div>
    )
  }

}

export default injectIntl(Swim)



// WEBPACK FOOTER //
// ./src/components/workouts/WorkoutForm/Swim.jsx